export default __webpack_public_path__ + "static/media/bug_fixed.805bfbc9.png";